export default __webpack_public_path__ + "static/media/12.d55672d3.png";